/* eslint-disable react/jsx-no-target-blank */
import { KTIcon } from '../../../helpers'

const SidebarFooter = () => {
  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer' >
      <button className='boton'> <span><a href="https://docs.transitxchange.cloud/uC2v3e2WlxXs6DwwVQ3y" target='_blank'><p ><i className="bi bi-info-circle"></i>  <span className="doc-text">Documentation</span> </p> </a></span></button>

      {/*<a
        href="/documentation"
        target='_blank'
        className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-decsription="DV004"
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='CTX Help & Support'
      >
        <span className='btn-label'><i className="bi bi-info-circle"></i> Documentation</span>
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
  </a>*/}

    </div>
  )
}

export { SidebarFooter }
